export const REQUEST_SEARCH_CLAIMS: string = 'REQUEST_SEARCH_CLAIMS';
export const SET_SEARCH_CLAIMS: string = 'SET_SEARCH_CLAIMS';

export const RESET_SEARCH_CLAIMS_STORE: string = 'RESET_SEARCH_CLAIMS_STORE';

export const SET_LOSS_DATE: string = 'SET_LOSS_DATE';

export const REQUEST_SEARCH_PANDING_CLAIMS: string =
  'REQUEST_SEARCH_PANDING_CLAIMS';
export const SET_SEARCH_PANDING_CLAIMS: string = 'SET_SEARCH_PANDING_CLAIMS';

export const SEND_EXISTING_CLAIMS_AND_DOCUMENT: string =
  'SEND_EXISTING_CLAIMS_AND_DOCUMENT';
export const SET_SELECTED_CLAIM: string = 'SET_SELECTED_CLAIM';
export const CANCEL = 'Annulé';
export const REQUEST_SUPPORT_DOCUMENTS: string = 'REQUEST_SUPPORT_DOCUMENTS';
export const SET_FOUND_CLAIMS: string = 'SET_FOUND_CLAIMS';
